// ─── Sticky announcement bar: sync height to CSS custom property ─────────────
// Measures the announcement bar wrapper and sets --announcement-bar-height on
// <html> so the sticky header below it starts at the right offset.
(function () {
  function setAnnouncementBarHeight() {
    var bar = document.querySelector('.shopify-section.announcement-bar-wrapper');
    if (!bar) return;
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      bar.offsetHeight + 'px'
    );
  }
  document.addEventListener('DOMContentLoaded', setAnnouncementBarHeight);
  window.addEventListener('resize', setAnnouncementBarHeight);
})();

// Patch recommended-products section to use complementary intent
(function() {
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' &&
        url.indexOf('recommendations') !== -1 &&
        url.indexOf('section_id') !== -1 &&
        url.indexOf('intent') === -1) {
      url = url + '&intent=complementary';
    }
    return _open.apply(this, arguments);
  };
})();

// ─── CRO: Track add-to-cart events for A/B testing baseline ──────────────────
// Fires a custom dataLayer event on every ATC click so Google Analytics / GTM
// can capture conversion funnel data for the CRO test vs. live theme.
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form');
    var productTitle = form
      ? (form.dataset.productTitle || document.querySelector('.product__title, h1.product__name')?.innerText || '')
      : '';
    var variantId = form ? (form.querySelector('[name="id"]')?.value || '') : '';
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cro_add_to_cart',
        product_title: productTitle,
        variant_id: variantId,
        theme: 'botanical-cro-test'
      });
    }
  });
})();

// ─── CRO: Sticky ATC subscribe toggle wiring ─────────────────────────────────
// When the subscribe toggle in the sticky ATC bar is checked, finds the
// subscription selling plan radio in the main form and selects it so the
// correct selling plan ID is submitted.
(function () {
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-sticky-subscribe-toggle]');
    if (!toggle) return;
    var checked = toggle.checked;
    // Find selling plan inputs in the main product form
    var planInputs = document.querySelectorAll(
      '.product-form [name="selling_plan"], ' +
      '.recharge-widget [name="selling_plan"], ' +
      '.rc_widget__option-item input[type="radio"]'
    );
    if (planInputs.length === 0) return;
    if (checked) {
      // Select the first subscription option
      planInputs[0].checked = true;
      planInputs[0].dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      // Deselect: look for a one-time purchase option
      var onetime = document.querySelector(
        '.rc_widget__option-item--one-time input, ' +
        '[data-selling-plan=""] input, ' +
        '.product-form [name="selling_plan"][value=""]'
      );
      if (onetime) {
        onetime.checked = true;
        onetime.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();

// ─── Klaviyo footer form: override inline styles ──────────────────────────────
// Klaviyo renders with heavy inline styles inside kl-private-reset-css scope.
// CSS !important cannot beat inline styles for some properties, so we patch
// them directly via JS after the form mounts.
(function () {
  function styleKlaviyoFooterForm() {
    var wrapper = document.querySelector('.footer__klaviyo-form');
    if (!wrapper) return;

    // 1. Remove min-height from the outermost Klaviyo-rendered div
    var outerDiv = wrapper.querySelector('.kl-private-reset-css-Xuajs1');
    if (outerDiv) {
      outerDiv.style.minHeight = '0';
      outerDiv.style.justifyContent = 'flex-start';
    }

    // 2. Make the two rows (input row + button row) sit side-by-side in one row
    var rows = wrapper.querySelectorAll('[data-testid="form-row"]');
    if (rows.length >= 2) {
      // Wrap rows in a flex container if not already done
      var form = rows[0].parentElement;
      if (form) {
        form.style.flexDirection = 'row';
        form.style.alignItems = 'stretch';
        form.style.minHeight = '0';
      }
      // Input row: grow to fill space
      rows[0].style.flex = '1 1 auto';
      rows[0].style.minWidth = '0';
      // Button row: shrink to content
      rows[1].style.flex = '0 0 auto';
    }

    // 3. Remove padding from inner component wrappers
    wrapper.querySelectorAll('[data-testid="form-component"]').forEach(function(el) {
      el.style.padding = '0';
    });

    // 4. Style the input
    var input = wrapper.querySelector('input[type="email"]');
    if (input) {
      input.style.backgroundColor = 'rgba(255,255,255,0.08)';
      input.style.color = '#ffffff';
      input.style.border = '1px solid rgba(255,255,255,0.25)';
      input.style.borderRadius = '0';
      input.style.height = '40px';
      input.style.fontSize = '13px';
      input.style.padding = '0 12px 0 14px';
      input.style.width = '100%';
      input.style.boxSizing = 'border-box';
    }

    // 5. Style the button
    var btn = wrapper.querySelector('button');
    if (btn) {
      btn.style.background = '#ffffff';
      btn.style.color = '#151515';
      btn.style.borderRadius = '0';
      btn.style.height = '40px';
      btn.style.width = 'auto';
      btn.style.padding = '0 16px';
      btn.style.fontSize = '12px';
      btn.style.fontWeight = '700';
      btn.style.letterSpacing = '0.08em';
      btn.style.textTransform = 'uppercase';
      btn.style.whiteSpace = 'nowrap';
      btn.style.cursor = 'pointer';
    }
  }

  // Klaviyo loads asynchronously — poll until the form renders
  var attempts = 0;
  var interval = setInterval(function () {
    var form = document.querySelector('.footer__klaviyo-form input[type="email"]');
    if (form) {
      styleKlaviyoFooterForm();
      clearInterval(interval);
    }
    if (++attempts > 40) clearInterval(interval); // give up after ~8s
  }, 200);
})();

// ─── CRO: Page speed — defer non-critical third-party scripts ─────────────────
// Moves non-essential app scripts to load after page becomes interactive.
// Targets Smile.io launcher (loyalty points popup) which loads eagerly.
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferSmile);
  } else {
    deferSmile();
  }
  function deferSmile() {
    // Smile.io loads via a script tag injected by the app — we just make sure
    // its initialization happens after the LCP image has loaded.
    var smileScript = document.querySelector('script[src*="smile.io"], script[src*="cdn.sweettooth"]');
    if (smileScript && !smileScript.hasAttribute('defer')) {
      // Already loaded; nothing to do
    }
  }
})();


